import app from "../../appInstance";
import topbarUnreadMessagesCounter from "./topbar/unreadMessagesCount.vue";
import topbarUnreadNotificationsCounter from "./topbar/unreadNotificationsCount.vue";
import topbarUnreadNotificationsDropdown from "./topbar/unreadNotifications.vue";
import topbarUnreadTopicsDropdown from "./topbar/unreadTopics.vue";
import topbarThemeSwitcher from "./topbar/TopbarThemeSwitcher.vue";
import topbarPrivacyModeToggle from "./topbar/TopbarPrivacyModeToggle.vue";

import sidebarUnreadMessagesCounter from "./sidebar/unreadMessagesCount.vue";
import sidebarUnreadNotificationsCounter from "./sidebar/unreadNotificationsCount.vue";
import sidebarUnreadEventsCounter from "./sidebar/unreadEventsCount.vue";

import makeMessagesAsRead from "./admin/messenger/makeMessagesAsRead.vue";
import makeNotificationAsRead from "./admin/notifications/makeNotificationAsRead.vue";

import latestNotifications from "./widgets/latestNotifications.vue";

import modelDiscussion from "./admin//discussion/modelDiscussion.vue";
import pageModulesEditor from "./admin/pages/pageModulesEditor.vue";
//Global

//Topbar
app.component("topbar-unread-messages-counter", topbarUnreadMessagesCounter);
app.component(
    "topbar-unread-notifications-counter",
    topbarUnreadNotificationsCounter
);
app.component(
    "topbar-unread-notifications-dropdown",
    topbarUnreadNotificationsDropdown
);
app.component("topbar-unread-topics-dropdown", topbarUnreadTopicsDropdown);
app.component("topbar-theme-switcher", topbarThemeSwitcher);
app.component("topbar-privacy-mode-toggle", topbarPrivacyModeToggle);

//Sidebar
app.component("sidebar-unread-messages-counter", sidebarUnreadMessagesCounter);
app.component(
    "sidebar-unread-notifications-counter",
    sidebarUnreadNotificationsCounter
);
app.component("sidebar-unread-events-counter", sidebarUnreadEventsCounter);

//Messenger
app.component("make-messages-as-read", makeMessagesAsRead);

//Notifications
app.component("make-notification-as-read", makeNotificationAsRead);

//Widgets
app.component("latest-notifications", latestNotifications);

//Discussion
app.component("model-discussion", modelDiscussion);

//Pages
app.component("page-modules-editor", pageModulesEditor);
